import React, { Fragment } from 'react';
import { FaSignInAlt } from 'react-icons/fa';
import { ArcaHttpClientLogin } from '../../code/ArcaHttpClientLogin';
import { ArcaHttpSystem } from '../../code/ArcaHttpSystem';
import { ArcaRedirect } from '../../code/ArcaRedirect';
import { ArcaSecurity } from '../../code/ArcaSecurity';
import { ArcaComponent } from './ArcaComponent';
import { Link } from "react-router-dom";

export class PeopleList extends ArcaComponent {

    constructor(props) {
        super(props);
        this.state = {
            isSmartphone: ArcaHttpSystem.IsSmartphone,
        };
    }

    resize() {
        this.setState({
            isSmartphone: ArcaHttpSystem.IsSmartphone
        });
    }

    //componentDidMount() {
    //    window.addEventListener("resize", this.resize.bind(this));
    // }

    //componentWillUnmount() {
    //    window.removeEventListener('resize', this.resize);
    //}

    render() {
        let { people, isLoading, type, status } = this.props;
        let { isSmartphone } = this.state;

        return (
            <Fragment>
                {people
                    ? people
                        .filter(p => type === null || type === undefined || p.Type === type)
                        .filter(p => (status === null) || (status === undefined) || (p.State === status))
                        .map((person, key) =>
                            <Fragment key={key}>
                                {ArcaHttpSystem.Log(`status=${status}`)}
                                <tr>
                                    <td>
                                        <Link to={"/PersonView?id=" + person.Id}>{person.FirstName} {person.LastName}</Link>
                                    </td>

                                    <td>
                                        {person.Postcode && person.Postcode.length > 4
                                            ? <span className='minilink' onClick={((postcode, name) =>
                                                this.setState({
                                                    postcode: postcode,
                                                    personName: name,
                                                    mapPopupOpen: true
                                                }))
                                                .bind(this, person.Postcode, person.FirstName + ' ' + person.LastName)} >

                                            </span>
                                            : null}
                                        {!isSmartphone
                                            ? `   ${person.AddressLine1 ?? ''} ${person.Postcode}`
                                            : person.Postcode}
                                    </td>


                                    {type === 'Owner'
                                        ? <td>
                                            {person.Pets.map((pet, key) =>
                                                <Fragment key={key}>
                                                    {pet.FullName}  {pet.Breed && !isSmartphone ? '(' + pet.Breed + ')' : null}
                                                </Fragment>)}
                                        </td>
                                        : null}

                                    <td>
                                        {ArcaSecurity.IsAdmin
                                            ? <span>
                                                <span
                                                    className='minilink'
                                                    onClick={this.onSignInAs.bind(this, person)} >
                                                    <FaSignInAlt
                                                        size='25px'
                                                    />
                                                    {'   '}
                                                                Login
                                                                </span>

                                            </span>
                                            : null}
                                    </td>
                                </tr>

                            </Fragment>)
                    : <Fragment>
                        <tr>
                            <td>
                                {isLoading
                                    ? 'Loading ...'
                                    : `No people match ${type}=>${status}`}
                            </td>
                        </tr>
                    </Fragment>
                }
            </Fragment>
        );
    }


    onSignInAs(person) {
        ArcaHttpClientLogin.LoginAsAsync(person.Email,
            ((user) => {
                alert(`Now logged in as '${user.firstName}'`);
                ArcaRedirect.Push('/Home');
            }))
    }
}